export { guard };

import type { GuardAsync } from "vike/types";
import { redirect } from "vike/abort";

const guard: GuardAsync = async (pageContext): ReturnType<GuardAsync> => {
  const {
    sessionCookie,
    urlParsed: { pathname, search },
  } = pageContext;
  if (search.promptLogin && sessionCookie) {
    throw redirect(pathname);
  }
};
